export default "__VITE_ASSET__CzSB$xwp__"